import { useAppSelector } from "store"

export const getFileVersionsFileIdSelector = () => useAppSelector(state => state.fileVersions.nodeId)

export const getFileVersionsStatusSelector = () => useAppSelector(state => state.fileVersions.status)

export const getFileVersionsSelectedVersionIdSelector = () => useAppSelector(state => state.fileVersions.selectedVersion)

export const getFileVersionsItemsSelector = () => useAppSelector(state => state.fileVersions.versions)